const ensureSettingsCategoryOpen = (categoryName: string): Promise<void> => {
  return new Promise((resolve) => {
    const menuRefreshInterval = window.setInterval(() => {
      const menu = document.querySelector(`[data-menu-category=${categoryName}]`);
      if (!menu) {
        return;
      }
      window.clearInterval(menuRefreshInterval);
      if (!menu.classList.contains("ant-menu-submenu-open")) {
        // open it then
        (menu.children[0] as HTMLElement).click();
      }
      resolve();
    }, 25);
  });
};

export default ensureSettingsCategoryOpen;
